<gridster class="bg-white dark:bg-layout-dark-page-container" [options]="options">
  @for (item of widgets; track item.id ?? $index) {
    <gridster-item class="bg-white dark:bg-layout-dark-page-container" [item]="item">
      <bo-widget class="bg-white bo-widget" [headerTemplate]="headerTemplate">
        <ng-container widget-header class="no-auto-text-color text-inherit">
          {{ item.title | transloco }}
        </ng-container>
        @if (getWidgetComponent(item); as component) {
          <ng-template
            [ngComponentOutlet]="component"
            [ndcDynamicInputs]="item.inputs"
          ></ng-template>
        } @else {
          <div
            class="flex overflow-auto p-2 w-full h-full border-2 border-gray-300 border-dashed dark:border-gray-500"
          >
            <span
              class="m-auto text-xs italic text-center text-gray-500 whitespace-normal break-words dark:text-gray-400"
            >
              {{ 'dashboard.widget.UNAVAILABLE_IN_APP' | transloco }}
            </span>
          </div>
        }
      </bo-widget>
    </gridster-item>
  }
</gridster>
